import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { greyColor } from "../colors";
import { Content } from "../Content";
import { Background } from "../home/Background";
import { HomeHeader } from "../home/Header";
import { mobileQuery } from "../MediaQuery";
import analytics from "../services/analytics";
import { ShareFooter, ShareMenu } from "../ShareTemplate";
import { SizedBox } from "../SizedBox";
import { StoreButtonsBlock } from "../StoreButtonsBlock";
import { translation } from "../translations";

type ParamTypes = {
  id: string;
};

const SocialShare: React.FC = (): JSX.Element => {
  const { id } = useParams<ParamTypes>();
  if (id === undefined) {
    throw Error("Unexpectedly unset id");
  }

  const image = `https://firebasestorage.googleapis.com/v0/b/vika-app/o/${id}.png?alt=media`;

  useEffect(() => {
    analytics.logPageView("socialShare");
  }, []);

  return (
    <Background>
      <ShareMenu />
      <Content>
        <TopWrapper>
          <PreviewImage src={image} />
          <DownloadHeader>{translation.useFreeApp}</DownloadHeader>
          <StoreButtonsBlock showStoreButtonsCallToAction={false} />
        </TopWrapper>
      </Content>
      <SizedBox desktopHeight={88} mobileHeight={48} />
      <HomeHeader includeNavigation={false} learnMore={true} />
      <ShareFooter />
    </Background>
  );
};

const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PreviewImage = styled.img`
  width: 600px;
  height: 316px;
  border-radius: 4px;
  margin: 64px 0 32px 0;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.3);
  ${mobileQuery`
    width: 300px;
    height: 158px;
    margin-bottom: 16px;
  `}
`;

const DownloadHeader = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${greyColor};
  margin: 0 0 8px 0;
`;

export default SocialShare;
